import { auto } from "async";
import React from "react";

export default class AvisoSimplificado extends React.Component {

  componentDidMount() {
    const _modalSim = document.getElementById("containerSimplificado");
    const _bodySim = document.querySelectorAll(
      "div#div-body-modal[modal-type='simplificado']"
    )[0];
    const _chage = function () {
      const h = window.innerHeight;
      _modalSim.height = h - 250;
      _modalSim.style.height = h - 250 + "px";
      _bodySim.height = h - 100;
      _bodySim.style.setProperty("height", h - 100 + "px", "important");
    };
    new ResizeObserver(_chage).observe(_modalSim);
    new MutationObserver(_chage).observe(_modalSim, {
      attributes: true,
      childList: true,
      characterData: true,
    });
  }

  render() {
    return ( //NOSONAR
      <div>
        <div>
          <h5 className="text-center">Aviso de privacidad integral</h5>
        </div>

        <div>
          <div
            style={{ height: "550px", overflowY: "auto", color: "#333333" }}
            id="containerSimplificado"
          >
            <p>
              Reconozco que previo a proporcionar los datos personales,
              incluyendo los del (los) menor(es) de edad de los cuales ostentó
              la patria potestad y/o debida representación legal o tutela en
              caso de aplicar, se ha puesto a mi disposición el Aviso de
              Privacidad Integral de Grupo Nacional Provincial, S.A.B. (en lo
              sucesivo GNP), el cual he leído y comprendido, por lo que tengo
              conocimiento de (i) la identidad y domicilio de GNP; (ii) los
              datos personales que serán sujetos a tratamiento; (iii) las
              finalidades primarias y secundarias del tratamiento, así como las
              transferencias que van a efectuarse; (iv) los medios habilitados
              para limitar el uso o divulgación de mis datos personales y/o
              revocar mi consentimiento, así como para ejercer mis derechos de
              acceso, rectificación, cancelación y oposición. Asimismo
              manifiesto tener conocimiento de que puedo consultar el Aviso de
              Privacidad Integral y sus actualizaciones en cualquier momento en
              la página.
            </p>
            <p>
              <b>GNP Seguros - Vivir es increíble | Sitio oficial</b>
            </p>
            <p>
              Por lo anterior, en mi carácter de titular, y/o padre o tutor del
              (los) menor (menores) de edad de los cuales ostentó la patria
              potestad y/o debida representación legal o tutela en caso de
              aplicar, una vez que he sido informado sobre el tratamiento al que
              serán sujetos los datos personales otorgo consentimiento, en caso
              de aplicar, para que Grupo Nacional Provincial, S.A.B. los trate
              en términos de lo señalado en el referido Aviso de Privacidad.
            </p>
            <p>
              En caso de haber proporcionado datos personales de otros
              titulares, incluyendo los del (los) menor(es) de edad, reconozco
              haber cumplido con mi obligación de informarles sobre su entrega,
              haber obtenido de forma previa el consentimiento de éstos para su
              tratamiento, y/o de quien(es) ostente(n) la patria potestad y/o
              debida representación legal o tutela en caso de aplicar; así como
              haberles informado los lugares en los que se encuentra disponible
              el Aviso de Privacidad Integral para su consulta. Entiendo que el
              consentimiento para el tratamiento de los datos personales no será
              necesario cuando la finalidad del tratamiento sea cumplir
              obligaciones derivadas de la relación jurídica.
            </p>
          </div>
        </div>

        <div className="text-center aceptar-cancelar-btn mt-20">
          <button
            type="button"
            id="btn-aceptar-modal"
            className="btn orange-btn"
            data-dismiss="modal"
            style={{
              width: "100px",
              height: "36px",
              letterSpacing: "1.25px",
              padding: "0px, 16px, 0px, 16px",
            }}
          >
            Aceptar
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/gnp-registro/avisoSimplificado.cmpt.js